// import { AnyCnameRecord } from "dns"

// const CALENDAR_ID = 'Calendar_id'
const TEAM_ARR = 'Team_arr'

export default class LocalTeamFilter {

  static myInstance: LocalTeamFilter
  public teamIsSet: boolean
  public teamArr: any

  constructor() {
    this.teamIsSet = true
    this.teamArr = []
  }

  setTeamArrLocally = (teamArr: any) => {
    // window.localStorage[CALENDAR_ID] = calendarId
    window.localStorage[TEAM_ARR] = JSON.stringify(teamArr)
    this.teamArr = teamArr
  }

  storeTeamArrLocally = () => {
    if (this.teamIsSet) {
      window.localStorage[TEAM_ARR] = this.teamArr
    }
  }

  fetchTeamArrLocally = () => {
    const data = window.localStorage[TEAM_ARR]
    if (data !== 'undefined' && data !== undefined && data !== '') {
      this.teamArr = data
    } else {
      this.teamArr = JSON.stringify([0, null])
    }
  }

  removeTeamArrLocally = () => {
    delete window.localStorage[TEAM_ARR]
  }

  static getInstance(): LocalTeamFilter {
    if (LocalTeamFilter.myInstance == null) {
      LocalTeamFilter.myInstance = new LocalTeamFilter();
    }
    return this.myInstance;
  }
}
